import {FieldProps, wdiCore, WdiModalAppProps} from "@/components/WdiControls";
import {Input, Popover, Tree} from "antd";
import {Key, useEffect, useRef, useState} from "react";
import {
  RebateStandardCustomizeModalApp,
  RebateStandardCustomizeModalValueProps
} from "@/pages/policy/ProductPolicyApply/components/rebateStandardCustomizeModal";
import {
  DateCustomizeType,
  DateCustomizeTypeMap
} from "@/pages/policy/ProductPolicyApply/components/rebateStandardDateCustomizeInput";
import {
  ProductCustomizeType,
  ProductCustomizeValueMap
} from "@/pages/policy/ProductPolicyApply/components/rebateStandardProductCustomizeInput";

const ModalType = {
  CUSTOMIZE: 1
}

//仅本页面用 用于区分参数类型 custom自定义
const StandardCalcType: {
  REACH: StandardCalcTypeProps,
  REBATE: StandardCalcTypeProps,
  CUSTOM: StandardCalcTypeProps
} = {
  REACH: {id: 1, name: "按达量产品计算", customizeType: ProductCustomizeType.REACH},
  REBATE: {id: 2, name: "按返利产品计算", customizeType: ProductCustomizeType.REBATE},
  CUSTOM: {id: 3, name: "自定义"},
}

type StandardCalcTypeProps = {
  id: number,
  name: string,
  customizeType?: ProductCustomizeType
}

const getStandardCalcType = (id: number) => {
  const calcTypeTemp: any = StandardCalcType;
  let result: StandardCalcTypeProps | undefined;
  Object.keys(calcTypeTemp).forEach(k => {
    const item: StandardCalcTypeProps = calcTypeTemp[k];
    if (item.id == id) {
      result = item;
      return;
    }
  })
  return result;
}


const getLevel3TreeNodes = (item: API.ProductPolicyParameter, dict: any) => {
  const parameterId = item.productPolicyParameterId;
  const result = []
  if (item.isProductSelectable) {
    result.push(
      getLevel3TreeNode(StandardCalcType.REACH, parameterId, dict),
      getLevel3TreeNode(StandardCalcType.REBATE, parameterId, dict),
    )
  }
  if (item.isCustomSelectable) {
    result.push(
      getLevel3TreeNode(StandardCalcType.CUSTOM, parameterId, dict),)
  }
  return result;
}

const getLevel3TreeNode = (calcType: StandardCalcTypeProps, parameterId: number, dict: any,) => {
  const key = `${parameterId}-${calcType.id}`
  const pId = `${parameterId}`
  const title = calcType.name;

  const treeNode: any = {
    title: title,
    value: key,
    id: key,
    key: key,
    pId: pId,
    choose: true,
    //filterKey: title1,
    isRoot: false
  };
  dict[key] = treeNode;
  return treeNode;
}

export type RebateStandardInputProps = {
  value?: string;
  onChange?: (result: any) => void;
  onBlur?: (callback: any, textAreaRef: any) => void;
  parameters?: API.ProductPolicyParameter[];
  rowNumber: number
}

const RebateStandardOptsInput: React.FC<RebateStandardInputProps> = (props) => {
  const [atIndex, setAtIndex] = useState<number>(0);
  const [searchState, setSearchState] = useState<{expandedKeys: Key[]; checkedKeys: Key[]; treeData: any[];}>({
    expandedKeys: [],
    checkedKeys: [],
    treeData: [],
  });
  const [treeState, setTreeState] = useState<{dict: any; dataSource: any[];}>({dict: {}, dataSource: []});
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [modalProps, setModalProps] = useState<WdiModalAppProps>({visible: false});

  let textAreaRef: any = useRef(null);

  const getCursorPosition = (ctrl: any) => {
    let caretPos = {
      start: 0,
      end: 0
    };
    if (ctrl?.current?.resizableTextArea?.textArea.selectionStart) {
      caretPos.start = ctrl?.current?.resizableTextArea?.textArea.selectionStart;
    }
    if (ctrl?.current?.resizableTextArea?.textArea.selectionEnd) {
      caretPos.end = ctrl?.current?.resizableTextArea?.textArea.selectionEnd;
    }
    return caretPos;
  }

  const dataConvert = (dataSource: API.ProductPolicyParameter[]) => {
    const typeNameMap = new Map<string, API.ProductPolicyParameter[]>();
    const treeData: any[] = [], dict: any = {};
    if (!wdiCore.Object.IsNullOrUndefined(dataSource)) {
      dataSource.forEach((item) => {
        const typeName = item.typeName
        if (typeNameMap.has(typeName)) {
          typeNameMap.get(typeName)?.push(item);
        } else {
          typeNameMap.set(typeName, [item]);
        }
      });
      const tempItems: any[] = [];
      typeNameMap.forEach((parameters, typeName) => {
        const rootTreeNode: any = {
          title: typeName,
          value: typeName,
          id: typeName,
          key: typeName,
          choose: false,
          //filterKey: title,
          isRoot: true
        };
        dict[typeName] = rootTreeNode;
        tempItems.push(rootTreeNode);
        parameters.forEach(item => {
          const level3Nodes = getLevel3TreeNodes(item, dict);
          const showLevel3 = level3Nodes.length > 0;
          const key = String(item.productPolicyParameterId);
          const pId = typeName;
          const title = item.parameterName;
          const treeNode: any = {
            title: title,
            value: key,
            id: key,
            key,
            pId,
            choose: !showLevel3,
            filterKey: title,
            isRoot: false
          };
          dict[key] = treeNode;
          tempItems.push(treeNode);
          if (showLevel3) {
            level3Nodes.forEach(l3Node => tempItems.push(l3Node));
          }
        })
      })

      tempItems.forEach((item) => {
        if (item.isRoot) {
          treeData.push(item);
        } else if (!wdiCore.Object.IsNullOrUndefined(item.pId)) {
          const parent = dict[item.pId];
          if (!wdiCore.Object.IsNullOrUndefined(parent)) {
            if (wdiCore.Object.IsNullOrUndefined(parent.children)) {
              parent.children = [];
            }
            parent.children.push(item);
          }
        }
      });
    }
    return {treeData, dict};
  };

  const onExpand = (expandedKeys: any) => {
    setSearchState((prevSearchState) => {
      return Object.assign({}, prevSearchState, {expandedKeys})
    });
  };

  const onSelect = (selectedKeys: any, e: any) => {
    if (e.node && e.node.value && e.node.choose) {
      const values = e.node.value.split('-');
      const item = props.parameters?.find(c => c.productPolicyParameterId == Number(values[0]));
      const calcType = getStandardCalcType(wdiCore.Number.ToInt(values[1]));
      if (StandardCalcType.CUSTOM == calcType) {
        setModalProps({
          visible: true,
          type: ModalType.CUSTOMIZE,
          data: {productPolicyParameter: item}
        })
        setPopoverVisible(false);
        return;
      }

      onSave(
        getFormatAtValue({
          productPolicyParameter: item,
          productCustomizeInputValue: {
            typeId: calcType?.customizeType
          },
          dateCustomizeInputValue: {
            typeId: DateCustomizeType.CURRENT
          }
        })
      );
      setPopoverVisible(false);
    }
  };

  const getFormatAtValue = (values: RebateStandardCustomizeModalValueProps) => {
    const parameter = values.productPolicyParameter;
    const optName = parameter?.parameterName.trim().substring(1, parameter?.parameterName.length - 1);
    const formatValueArr = [optName]
    const productCustomizeValue = values.productCustomizeInputValue;
    if (productCustomizeValue?.typeId) {
      formatValueArr.push(ProductCustomizeValueMap.get(productCustomizeValue.typeId) ?? '')
    }

    const dateCustomizeValue = values.dateCustomizeInputValue;
    if (dateCustomizeValue?.typeId) {
      let typeName = DateCustomizeTypeMap.get(dateCustomizeValue.typeId) ?? '';
      if (DateCustomizeType.CURRENT == dateCustomizeValue.typeId) {
        typeName = ''
      }
      if (DateCustomizeType.DYNAMIC == dateCustomizeValue.typeId) {
        const dynamicDateValue = dateCustomizeValue.dynamicDateValue;
        typeName += ':' + wdiCore.String.Join(dynamicDateValue?.startDay, dynamicDateValue?.endDay, ' ~ ')
      }
      formatValueArr.push(typeName)
    }
    return `{${formatValueArr.filter(item => item).join(', ')}}`;
  }

  const onSearch = (value: any, e: any) => {
    const newTreeData = loop(treeState.dataSource, value);
    //搜索之后展开全部节点
    const newExpandedKeys = FieldProps.TreeSelect.getAllKeys(newTreeData);
    setSearchState((prevSearchState) => ({
      treeData: newTreeData,
      expandedKeys: newExpandedKeys,
      checkedKeys: prevSearchState.checkedKeys
    }));
  }

  const loop = (gData: any[], filterValue: string | null) => {
    if (wdiCore.String.IsNullOrEmpty(filterValue)) {
      return gData;
    }
    const newData: any[] = [];
    (gData ? gData : []).forEach((item => {
      const {children, ...newItem} = item;
      if (newItem.filterKey && wdiCore.String.Match(newItem.filterKey, filterValue)) {
        newData.push(item);
      } else if (children && children.length) {
        const subChildren = loop(children, filterValue);
        if (subChildren && subChildren.length) {
          newItem.children = subChildren;
          newData.push(newItem);
        }
      }
    }));
    return newData;
  };

  const treeReload = () => {
    const data = dataConvert(props.parameters ?? []);
    setTreeState({dataSource: data.treeData, dict: data.dict});
    const newTreeData = loop(data.treeData, '');
    setSearchState((prevSearchState) => {
      const currentExpandedKeys = prevSearchState.expandedKeys;
      let newExpandedKeys: Key[] = [];
      if (currentExpandedKeys && currentExpandedKeys.length) {
        currentExpandedKeys.forEach((item) => {
          if (data.dict && data.dict[item]) {
            newExpandedKeys.push(item);
          }
        });
      }
      if (!newExpandedKeys.length) {
        newExpandedKeys = FieldProps.TreeSelect.getTreeExpandedKeys(newTreeData);
      }
      return {treeData: newTreeData, expandedKeys: newExpandedKeys, checkedKeys: []}
    });
  }

  useEffect(() => {
    treeReload();
  }, [props]);

  const onSave = (value?: string) => {
    onSaveFunc(atIndex, value);
  }
  const onSaveFunc = (atIndex: number, value?: string) => {
    const textAreaValue = props.value ?? '';
    const preStr = textAreaValue.substring(0, atIndex)
    const sufStr = textAreaValue.length > 1 ? textAreaValue.substring(atIndex, textAreaValue.length) : '';
    const resultStr = preStr + value + sufStr;
    props.onChange?.(resultStr);
    textAreaRef?.current?.focus();
    setCursorPosition(textAreaRef?.current?.resizableTextArea.textArea, atIndex + ((value ?? '').length));
  }

  const addOptionFunc: Function = (optStr: string, textAreaRefa: any) => {
    const position = getCursorPosition(textAreaRef);
    const atIndex = position.start;
    onSaveFunc(atIndex, optStr);
    if (optStr == '@') {
      inputAtStrFunc(atIndex + optStr.length);
    }
    if (['Round()', 'Min()'].includes(optStr)) {
      const roundIndex = atIndex + (optStr.length - 1);
      setCursorPosition(textAreaRefa.current.resizableTextArea.textArea, roundIndex);
    }
  }

  const inputAtStrFunc = (startPosition: number) => {
    setAtIndex(startPosition);
    setPopoverVisible(true);
  }

  const setCursorPosition = (ctrl: any, pos: number) => {
    setTimeout(() => {
      ctrl.setSelectionRange(pos, pos);
    }, 0)
  };

  return (
    <>
      {modalProps.visible && ModalType.CUSTOMIZE == modalProps.type &&
        <RebateStandardCustomizeModalApp
          {...modalProps}
          value={modalProps.data}
          onSave={(result) => {
            const values: RebateStandardCustomizeModalValueProps = result?.data;
            onSave(getFormatAtValue(values));
            setModalProps({visible: false});
          }}
          onClose={() => setModalProps({visible: false})}
        />

      }
      <Popover destroyTooltipOnHide={true} visible={popoverVisible} trigger='click'
               onVisibleChange={(visible) => {
                 setPopoverVisible(visible)
               }}
               placement={props.rowNumber > 3 ? 'topLeft' : 'bottomLeft'}
               content={<div style={{maxHeight: 400, overflowY: 'auto'}}>
                 <Input.Search
                   autoFocus={true}
                   style={{marginBottom: 10}}
                   placeholder="请输入参数名称"
                   onSearch={onSearch}/>
                 <Tree
                   checkStrictly
                   onSelect={onSelect}
                   onExpand={onExpand}
                   checkedKeys={searchState.checkedKeys}
                   expandedKeys={searchState.expandedKeys}
                   treeData={searchState.treeData}
                 />
               </div>}>
      </Popover>
      <Input.TextArea
        readOnly={popoverVisible}
        ref={textAreaRef}
        style={{resize: 'none'}}
        value={props.value}
        onChange={(e) => {
          props.onChange?.(e.target.value);
        }}
        onInput={(e: any) => {
          if (e.nativeEvent?.data == '@') {
            const position = getCursorPosition(textAreaRef);
            inputAtStrFunc(position.start);
          }
        }}
        onBlur={(e) => {
          props.onBlur?.(addOptionFunc, textAreaRef);
        }}
      >
      </Input.TextArea>

    </>
  );
};

export default RebateStandardOptsInput;
